import Slider from "rc-slider";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

interface NoiseLevelProps {}

export const NoiseLevelSetting: WidgetSettingFC<string, NoiseLevelProps> = ({ data, setData }) => {
  const loudThreshold = Number(data);

  return (
    <>
      <FormLabel>Max Noise</FormLabel>
      <InnerContainer>
        <Slider
          step={null}
          onChange={(value) => setData(String(Number(value) / 100))}
          defaultValue={loudThreshold * 100}
          value={loudThreshold * 100}
          style={{ height: "100%" }}
          marks={{
            0: <></>,
            16.6: <></>,
            33.2: <></>,
            50: <></>,
            66.5: <></>,
            83: <></>,
            100: <></>,
          }}
          trackStyle={{
            backgroundColor: "var(--primary)",
            height: "10px",
            transform: "translateY(-50%)",
            top: "50%",
          }}
          railStyle={{
            backgroundColor: "#DDE1E8",
            height: "10px",
            transform: "translateY(-50%)",
            top: "50%",
          }}
          dotStyle={{
            top: "50%",
            borderRadius: "1cqw",
            height: "8cqw",
            width: "2cqw",
            backgroundColor: "#DDE1E8",
            transform: "translate(-50%, -50%)",
            border: "none",
          }}
          activeDotStyle={{
            backgroundColor: "var(--primary)",
          }}
          handleStyle={{
            backgroundColor: "var(--primary)",
            borderColor: "var(--primary)",
            width: "9cqw",
            height: "9cqw",
            opacity: "1",
            top: "50%",
            transform: "translate(-50%, -50%)",
            marginTop: "0px",
          }}
        />
      </InnerContainer>
    </>
  );
};

const InnerContainer = styled.div`
  padding: 20px;
  margin-bottom: 35px;

  .rc-slider-step {
    height: 100%;
    position: relative;
  }
`;

const FormLabel = styled.p`
  color: var(--secondary);
  font-weight: 600;
  font-size: 12pt;
`;
